import React from 'react';
import PropTypes from 'prop-types';
import FeaturedImage from '../FeaturedImage';
import useSettingsContext from '../../context/useSettingsContext';
import useCore from '../../methods/core/useCore';
import useUtilities from '../../methods/utilities/useUtilities';

function CorporatePost(props) {
	const {
		postType,
		displayAuthor,
		displayExcerpt,
		displayDate,
		displayCategories
	} = useSettingsContext();

	const { post } = props;
	const { replaceSelected } = useCore();
	const { theExcerpt } = useUtilities();
	let categories;
	let category;
	let postCategory;
	let postCategoryLink;
	let featuredImage;
	let author;
	let excerpt;
	let readTime;
	let classPost = 'post-card corporate-post-card';
	let permalink;

	CorporatePost.propTypes = {
		post: PropTypes.object
	}

	if (post.featured_image !== undefined && post.featured_image) {
		featuredImage =
			<figure className="post-card__featured-image corporate-post-card__featured-image">
				<FeaturedImage
					imageSize={'post-grid'}
					image={post.featured_image}
					srcset={post.featured_image}
				></FeaturedImage>
			</figure>
	} else {
		classPost += ' post-card--no-thumb';
	}


	if (post.the_categories !== undefined && post.the_categories.length > 0) {
		categories = post.the_categories;
	}

	if (categories && displayCategories) {
		categories.forEach((el, index) => {
			if (el.taxonomy === 'category' && index === 0 && el.slug !== 'uncategorized') {
				postCategory = el.name;
				postCategoryLink = el.link;
				return;
			}
		})
	}

	if (postCategory) {
		category = <a className="post-card__cat corporate-post-card__cat" href={postCategoryLink} aria-label={postCategory} dangerouslySetInnerHTML={{ __html: postCategory }}/>;
	}

	if (post.the_author !== undefined && displayAuthor) {
		author = <a href={post.acf_data.author_link} className="post-card__author corporate-post-card__author">By {post.the_author}</a>
	}

	if (post.acf_data.full_excerpt && displayExcerpt) {
		excerpt = <div className="post-card__excerpt corporate-post-card__excerpt">
			{post.acf_data.full_excerpt}
		</div>
	}



	if (post.acf_data.read_time) {
		readTime = (
			<span className="post-card__read-time corporate-post-card__read-time">{post.acf_data.read_time}</span>
		);
	}

	if (post.link) {
		permalink = <a href={post.link} className="post-card__permalink corporate-post-card__permalink" aria-label={post.title.rendered}></a>
	}

	return (
		<article id={`${postType}-${post.id}`} className={classPost}>
			{permalink}
			{featuredImage}
			{category}

			<div className="post-card__wrapper corporate-post-card__wrapper">
				<h3 className="post-card__title corporate-post-card__title" dangerouslySetInnerHTML={{ __html: post.title.rendered }}></h3>

				{excerpt}
				<div className="post-card__detail corporate-post-card__detail">
					{readTime}
				</div>
			</div>
		</article>
	);
}

export default CorporatePost;

